<template>
<div class="edit_banks_tags">
  <v-data-table
      dense
      :headers="headers"
      :items="desserts"
      :search="searchBankTags"
      class="elevation-1"
    >
    <!-- :sort-by.sync="sortBankCS"
      :sort-desc.sync="sortBankDesc"
      :items-per-page.sync="updateBankItemsPerPage" -->
    <!-- @update:sort-by="OnBankSortBy($event)"
      @update:sort-desc="OnBankSortDesc($event)"
      @update:items-per-page="OnUpdateBankItemsPerPage($event)" -->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Банки</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field
            v-model="searchBankTags"
            append-icon="search"
            clearable
            label="Поиск ..."
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small @click="deleteItem(item)"> delete </v-icon>
      </template>
    </v-data-table>
    <v-progress-linear
      :active="loading"
      :indeterminate="loading"
      absolute
      bottom
      color="deep-purple accent-4"
    ></v-progress-linear>
</div>
</template>
<script>
export default {
  name: 'edit_banks_tags',
  components:{},
  data:()=>({
    loading: false,
    searchBankTags: '',
    headers: [
      {
        text: "Название",
        align: "left",
        sortable: false,
        value: "name",
      },
      { text: "Опимание", value: "description" },
      { text: "Действия", value: "action", sortable: false, width: 90 },
    ],
  }),
  props:{},
  methods:{
    async init(){
      await this.$store.dispatch('GetBanksTags')
    },
    async deleteItem(item){
      await this.$store.dispatch('DeleteBanksTag',item.id)
    },
  },
  computed:{
    desserts(){
      return this.$store.getters.getBanksTags
    }
  },
  mounted(){
    this.init()
  },
  watch:{}
}
</script>
<style lang="sass" scoped>

</style>
